/** @module ProductSpec/SizeChart/MassUpdateShapeStylesPropertiesForm */
define([
    "dojo/_base/declare",
    "csi/locale",
    "./StyleSizeChartMixin"
], function(declare,locale,StyleSizeChartMixin) {

    return declare(StyleSizeChartMixin, {

        FIELD_STYLE_SIZE_CHARTS: "StyleSizeCharts",

        /**
         * Resolves view for shape size charts on properties view
         */
        _resolveView: function() {
            var fieldSizeCharts = this.getFieldSizeCharts();
            this.inherited(arguments);
            fieldSizeCharts.m_label = locale.typePlural("SizeChart");
        },


        /**
         * Gets Field Style Size Chart Store
         * @param {Field} field
         * @param {String} value
         */
        getFieldStore: function(field,value) {

            switch(field.getControlName()){
                case this.FIELD_STYLE_SIZE_CHARTS:
                    return this.getFieldStyleSizeChartStore(field);
                default:
                    return this.inherited(arguments);
            }
        }

    });
});